// The config format:
// const config = [
//   { path: "/01-step/" },
//   { path: "/02-step/", skipCount: true },
// ]

export default (config) => (activeStepPath) => ({
  progressStep: null,
  totalSections: null,
  progressWidth: 0,
  currentSectionIndex: null,
  completedStepReached: null,
  currentSectionTitleKey: null,

  init() {
    this.pageState = Alpine.store("pageState")
    this.totalSections = config
    this.currentSectionIndex = this.getCurrentSectionIndex()
    this.currentSectionTitleKey = this.getCurrentSectionTitleKey(null)

    this.progressStep = this.getProgressStep(activeStepPath)
    this.totalSteps = this.getTotalSteps()
    this.progressWidth = this.getProgressWidthSingle()

    setTimeout(() => {
      this.getProgressWidthMultipleSteps()
      this.getTotalSectionsSteps()
      this.currentSectionTitleKey = this.getCurrentSectionTitleKey(null)
    })
  },

  getCurrentSectionIndex() {
    for (let i = 0; i < config.length; i++) {
      const section = config[i]
      const stepExists = section.steps.some(
        (step) => step.path === this.pageState.activeStepFileSlug,
      )
      if (stepExists) return i
    }
    return -1
  },

  getCurrentSectionTitleKey(fallback = null) {
    const idx = this.currentSectionIndex
    if (idx == null || idx < 0) return fallback

    const section = config[idx]
    const value = section?.titleKey
    return typeof value === "string" && value.trim() ? value.trim() : fallback
  },

  getTotalSectionsSteps() {
    const activeSection = config[this.currentSectionIndex]

    // Only steps that count
    const countableSteps = activeSection.steps.filter((step) => !step.skipCount)
    const stepProgressWidth = 100 / countableSteps.length
    let completedCount = 1

    for (const step of activeSection.steps) {
      if (step.path === this.pageState.activeStepFileSlug) break
      if (!step.skipCount) completedCount++
      if (step.completed) {
        return (this.completedStepReached = true)
      }
    }

    return completedCount * stepProgressWidth
  },

  getProgressWidthMultipleSteps() {
    config.forEach((sectionConfig, index) => {
      const sectionEl = document.getElementById(`pipe-progress-bar-${index}`)
      if (!sectionEl) return

      const fill = sectionEl.querySelector(".pipe-progress-bar-fill")

      if (index < this.currentSectionIndex) {
        // Previous sections -> mark completed
        sectionEl.classList.add("pipe-progress-bar-completed")
        return
      }
      if (index === this.currentSectionIndex) {
        const sectionProgress = this.getTotalSectionsSteps()

        if (fill) {
          fill.style.width = sectionProgress + "%"
        }

        sectionEl.classList.toggle("pipe-progress-bar-completed", this.completedStepReached)

        this.currentSectionTitleKey = this.getCurrentSectionTitleKey(null)

        return
      }
      sectionEl.classList.remove("pipe-progress-bar-completed")

      if (fill) {
        return (fill.style.width = "0%")
      }

      return
    })
  },

  getProgressWidthSingle() {
    return (this.progressStep * 100) / this.totalSteps
  },

  getProgressStep(activeStepPath) {
    // TODO: the `activeStepPath` argument is kept for backward compatibility.
    // Future pipes should rely on the shared `this.pageState.activeStepFileSlug`
    const activePath = activeStepPath || this.pageState?.activeStepFileSlug
    const stepsObject = config[0].steps

    // Calculations based on actual pages files slugs used in dev (and not path names defined by product)
    const currentStepIndex = stepsObject.findIndex((step) => step.path === activePath)

    return stepsObject
      .slice(0, currentStepIndex + 1) // Get all previous steps including the current one
      .filter((step) => !step.skipCount).length // Filter out the steps that should not be counted
  },

  getTotalSteps() {
    return config[0].steps.filter((step) => !step.skipCount).length // Filter out the steps that should not be counted
  },
})
